import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {CourtDTO} from '../model/courtDTO';

@Injectable({
  providedIn: 'root'
})
export class CourtService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'courts';

  constructor(private http: HttpClient) {
  }

  getAll() {
    return this.http.get<Array<CourtDTO>>(`${this.path}`);
  }
}
